/*
    Author: draplater
    Create Time: 17-7-28
    Project: verbnet2017
*/

import * as React from 'react';
import {GlobalState} from "../reduxSetting";
import {groupBy} from "../tagUtils";
import {connect} from "react-redux";
import {SearchResult} from "./search";
import {Breadcrumb, BreadcrumbItem, Panel, Table} from "react-bootstrap";
import {Link} from "react-router-dom";
import {FrameMeta} from "../problem-domain/frame";
import * as DocumentTitle from 'react-document-title';


namespace FrameIndexPage {
    export interface Props {
        frameIndex: FrameMeta;
    }

    export interface State {
        cmp: (a: string[], b: string[]) => number
    }

}

const cmpByVerb = (a, b) => a.slice(-1)[0].localeCompare(b.slice(-1)[0]);
const cmpByFrame = (a, b) => a.toString().localeCompare(b.toString());

function mapStateToProps(state: GlobalState, ownProps) {
    return {
        frameIndex: {name: "", sub_frames: state.index.frames, lexicons: []}
    };
}

export class FrameIndexPage extends React.Component<FrameIndexPage.Props, FrameIndexPage.State> {

    constructor(props) {
        super(props);
        this.state = {cmp: cmpByFrame};
    }

    renderOneGroup(name: string, frames: string[][]) {
        return (
            <div className="search-result">
                <h2> Archi Frame: {name} </h2>
                <Table striped bordered condensed hover>
                    <thead>
                    <tr>
                        <th>Basic Frame</th>
                        <th>Frame Relation</th>
                    </tr>
                    </thead>
                    <tbody>
                    {frames.map(x => SearchResult.renderRow(x, this.props.frameIndex, false))}
                    </tbody>
                </Table>
            </div>
        );
    }

    render(): JSX.Element {
        if (this.props.frameIndex === undefined) {
            return <p> Loading...</p>;
        } else {
            const lexicons = SearchResult.findMatchedFrames(
                this.props.frameIndex, [], "")
                .filter(x => x.length > 1); // ignore archi frame itself
            const lexiconGroups = groupBy(lexicons, path => path[0]);
            Array.from(lexiconGroups.entries()).forEach(([key, value]) => value.sort(this.state.cmp));
            return (
                <div>
                    <Breadcrumb>
                        <BreadcrumbItem>
                            <Link to="/"> VerbNet </Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem active>
                            <Link to="/frame-index"> Frames </Link>
                        </BreadcrumbItem>
                    </Breadcrumb>
                    {/*<div style={{float: "right"}}>*/}
                    {/*<Form>*/}
                    {/*<Radio name="order"*/}
                    {/*onClick={() => this.setState({cmp: cmpByVerb})}*/}
                    {/*checked={this.state.cmp == cmpByVerb}> Order by Verb </Radio>*/}
                    {/*<Radio name="order"*/}
                    {/*onClick={() => this.setState({cmp: cmpByFrame})}*/}
                    {/*checked={this.state.cmp == cmpByFrame}> Order by Frame </Radio>*/}
                    {/*</Form>*/}
                    {/*</div>*/}
                    <h1> Frames </h1>
                    {Array.from(lexiconGroups.entries())
                        .map(([key, value]) => this.renderOneGroup(key, value))
                    }
                </div>
            );
        }
    }
}

export const FrameIndexPageRedux = connect(mapStateToProps)(FrameIndexPage as any);

export function renderFrameIndexWithRouter() {
    return (<DocumentTitle title="Frames - Mandarin VerbNet">
            <Panel>
                <FrameIndexPageRedux/>
            </Panel>
        </DocumentTitle>
    );
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FrameIndexPage.tsx